import { Flex } from '@podiumhq/design-system';
import {
  US_STATES,
  CANADIAN_COUNTRY_CODE,
  CANADIAN_PROVINCES,
} from 'components/BusinessDetails';
import {
  ADDRESS_FIELD,
  ADDRESS_OPTIONAL_FIELD,
  CITY_FIELD,
  COUNTRY_FIELD,
  POSTAL_CODE_FIELD,
  STATE_FIELD,
} from 'components/FormElements/constants';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { BillingAddressFormWrapper } from '../../styles';

import { AddressInput } from './AddressInput';

export const BillingAddressForm = (props) => {
  const {
    billingAddress = {},
    billingAddressErrors: errors = {},
    isMobile,
    setBillingAddress,
    setBillingAddressErrors: setErrors,
  } = useSelectPlanCheckoutContext();

  const inputProps = {
    addressDetails: billingAddress,
    errors,
    setAddressDetails: setBillingAddress,
    setErrors,
  };

  const flexWrapperStyles = {
    ...(isMobile && { direction: 'column' }),
    justify: 'stretch',
  };

  const marginRight = isMobile ? '0' : '16px';
  const largeChildWrapperStyles = { width: '55%' };
  const smallChildWrapperStyles = { width: '41%' };

  const cityStateWrapperStyles = {
    ...flexWrapperStyles,
    ...(!isMobile && {
      sx: {
        '> div:first-of-type': { ...largeChildWrapperStyles, marginRight },
        '> div:last-child': smallChildWrapperStyles,
      },
    }),
  };

  const zipCountryWrapperStyles = {
    ...flexWrapperStyles,
    ...(!isMobile && {
      sx: {
        '> div:first-of-type': { ...smallChildWrapperStyles, marginRight },
        '> div:last-child': largeChildWrapperStyles,
        marginBottom: '-24px',
      },
    }),
  };

  return (
    <BillingAddressFormWrapper mt={props.mt ? props.mt : '24px'}>
      <AddressInput fieldName={ADDRESS_FIELD} {...inputProps} />

      <AddressInput fieldName={ADDRESS_OPTIONAL_FIELD} {...inputProps} />

      <Flex {...cityStateWrapperStyles}>
        <AddressInput fieldName={CITY_FIELD} {...inputProps} />
        <AddressInput
          fieldName={STATE_FIELD}
          selectList={
            billingAddress.country === CANADIAN_COUNTRY_CODE
              ? CANADIAN_PROVINCES
              : US_STATES
          }
          {...inputProps}
        />
      </Flex>

      <Flex {...zipCountryWrapperStyles}>
        <AddressInput fieldName={POSTAL_CODE_FIELD} {...inputProps} />
        <AddressInput fieldName={COUNTRY_FIELD} {...inputProps} />
      </Flex>
    </BillingAddressFormWrapper>
  );
};
